import React from "react";

const OurStory = ({ t }) => {
  // Sigurnosna provjera - ako t nije poslan, komponenta se ne prikazuje
  if (!t) return null;

  return (
    <section className="our-story minimal" id="story">
      <div className="container">
        <div className="story-grid">
          {/* LIJEVA STRANA: SLIKA */}
          <div className="image-wrapper">
            <div className="image-frame">
              <img
                src="https://images.unsplash.com/photo-1519741497674-611481863552?q=80&w=800"
                alt="Matea & Reinier"
              />
              <div className="frame-decoration"></div>
            </div>
          </div>

          {/* DESNA STRANA: TEKST */}
          <div className="content-wrapper">
            <h4 className="serif-font">{t.storyJourney}</h4>
            <h2 className="script-font">{t.storyTitle}</h2>

            <div className="divider-line"></div>

            <div className="story-body">
              <p>{t.storyText1}</p>
              <p className="highlight-text serif-font">{t.storyQuote}</p>
              <p>{t.storyText2}</p>
            </div>
            <div className="divider-line mobile-hide"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
